import { render, staticRenderFns } from "./DoctorFormModal.vue?vue&type=template&id=54baccc8&scoped=true&"
import script from "./DoctorFormModal.vue?vue&type=script&lang=js&"
export * from "./DoctorFormModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorFormModal.vue?vue&type=style&index=0&id=54baccc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54baccc8",
  null
  
)

export default component.exports